import { Button } from "antd";
import styled from "styled-components";
import { ReactSVG } from "react-svg";

export const DailyPlanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 10px;
  overflow: hidden;
  overflow-y: auto;
  margin-bottom: 55px;
  width: 100%;
  padding: 0 5px 0 5px;
`;

export const WeekDayWrapper = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 5px;
  margin-right: 5px;
`;

export const WeekDay = styled.div`
  font-size: 16px;
  width: 10%;
  text-align: center;
  color: ${({ theme: { colors } }) => (colors.grayColors.darkGray)};
`;

export const DailyCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  padding-right: 5px;
  padding-left: 5px;
  overflow: hidden;
  overflow-y: auto;
`;

export const StyledLeftButton = styled(Button)`
    display: flex;
    background-color: transparent;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: none !important;
    width: 30px;
    height: 50px;
    margin-left: 10px;
    margin-top: 5px;

    &:hover, &:focus {
        border: none !important;
        background-color: transparent !important;
    }
`;

export const StyledRightButton = styled(Button)`
    display: flex;
    background-color: transparent;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: none !important;
    width: 30px;
    height: 50px;
    margin-right: 10px;
    margin-top: 5px;

    &:hover, &:focus {
        border: none !important;
        background-color: transparent !important;
    }
`;

export const StyledSVGRight = styled(ReactSVG)`
    fill:  ${({ theme: { colors } }) => colors.grayColors.lightGray};
    position: absolute;
    right: 0;
`;

export const StyledSVGLeft = styled(ReactSVG)`
    fill:  ${({ theme: { colors } }) => colors.grayColors.lightGray};
    position: absolute;
    left: 0;
`;

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const FooterContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: fixed;
    justify-content: space-between;
    bottom: 0;
    width: 100%;
    height: 55px;
    z-index: 500;
    text-align: center;
    background-color: ${({ theme: { colors } }) => colors.mainColors.blue};
`;

export const TextFooter = styled.div`
  font-size: 21px;
  @media only screen and (max-width: 330px) {
      font-size: 19px;
  }
  @media only screen and (max-width: 320px) {
      font-size: 17px;
  }
  @media only screen and (max-width: 290px) {
      font-size: 15px;
  }
  align-self: center;
  color: ${({ theme: { colors } }) => colors.grayColors.lightGray};
  width: 100%;
  &.currentMonth {
      font-weight: 700;
  }
`;

export const TextFooterVersion = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin-top: -8px;
  opacity: 0.6;
  text-transform: uppercase;
  text-align: center;
`;

export const NoMonthlyPlansMessage = styled.div`
  font-size: x-large;
  text-align: center;
`;

export const NoMonthlyPlansWrapper = styled.div`
  height: 75vh; 
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const SheetRow = styled.div`
  width: 100%;
  display: flex;
  height: 40px;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 5px;
  padding: 0 !important;
`;

export const LeftBar = styled.div`
  gap: 3px;
  display: flex;
  flex-direction: column;
`;

export const EmployeeNameCell = styled.div`
 // font-family: MontserratWeb-SemiBold;
  width: 160px;
  // text-wrap: no-wrap;
 // line-height: 40px;
  color: white;
 // box-sizing: border-box;
 // cursor: pointer;
  font-size: 12px;
  border-radius: 5px;
  background-color: ${(props) => (props?.isShiftManager ? '#F6C8BD' : 'none')};
  border: 1px solid #C5C5C5;
  padding: 3px 5px 0 5px;
  text-align: left !important;
  font-weight: 500;
  position: relative;
  color: #393939;
  flex-direction: column;
  gap: 0px !important;
  /* &.selected {
    color: white;
    background: transparent !important;
    border: 0px !important;
  }
  transition: all 0.5s; */
  /* word-break: break-word;
  white-space: normal; */
  height: 40px;
`;

export const EmployeeName = styled.div`
  
`;

export const EmployeeSurname = styled.div`
  margin-top: -3px;
`;

export const RightBar = styled.div`
  gap: 3px;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  ::-webkit-scrollbar {
    display: none;
  }
  width: 100%;
`;

export const EmployeeTimelineCell = styled.div`
  // width: calc(100% - 160px);
  width: 100vw;
  height: 40px;
  border: 1px solid #C5C5C5;
  border-radius: 5px;
  position: relative;
  //box-sizing: border-box;
`;




export const Container = styled.div`
  //padding: 20px 0px;
  height: 100%;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
 // padding-top: 120px;
`;

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  margin-top: 30px;
  //padding: 0 10px;
  background-color: rgb(230, 230, 230);
`;

export const FixedColumn = styled.div`
  //background: #f8f9fa;
  width: 100px;
  position: sticky;
  left: 0;
  z-index: 44;
  background-color: rgb(230, 230, 230);
  //border-right: 1px solid #ccc;
`;

export const ScrollableWrapper = styled.div`
  flex: 1;
  /* overflow: auto; */
  /* overflow-x: auto;
  scrollbar-width: none; */
  padding-left: 8px;
`;

export const Table = styled.table`
  border-collapse: collapse;
  /* position: relative; */
  /* overflow-x: hidden;
  overflow-y: scroll; */
  background-color: #e6e6e6;
  width: 100%;
`;

export const Thead = styled.thead`
`;

export const Tbody = styled.tbody`
 // background-color: white;
  gap: 4px;
  display: flex;
  flex-direction: column;
`;

export const TbodyNames = styled.tbody`
 // background-color: white;
  gap: 4px;
  display: flex;
  flex-direction: column;
  margin-left:10px;
  background-color: rgb(230, 230, 230);
`;

export const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  background: #e9ecef;
  //background-color: rgb(230, 230, 230);
  text-align: center;
`;

export const TdNames = styled.td`
  position: relative;
  //border: 1px solid #ddd;
  border: 1px solid #C5C5C5;
  // padding: 8px;
  text-align: center;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  height: 49px;
  // gap: 0.2px;
  width: 100px;
  border-radius: 5px;
  background-color: ${(props) => {
    if (props?.isStudent) return '#95dea8';
    if (props?.isShiftManager) return '#F6C8BD';
    return 'none';
  }};
`;

export const Td = styled.td`
  border: 1px solid #ddd;
  border-radius: 5px;
  // padding: 8px;
  text-align: center;
  display: flex;
  flex-direction: row;
  height: 49px;
  // gap: 0.2px;
`;

export const HoursShiftDiv = styled.div`
  width: 44.43px;
  height: 45px;
  background-color: #C9C9C9;
  border-radius: 5px;
  position: relative;
  display: flex;
`;

export const ObligationDiv = styled.div`
  width: 22.4px;
  background-color: red;
  position: absolute;
 // margin: 2px 0;
  height: 100%;
  font-size: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 5px;
  border: 1px solid gray;
  background-color: ${(props) => {
    // New color scheme based on sector short name
    const colorMap = {
      'L': '#78D59A',
      'LU': '#78D59A',
      'U': '#FFC067',
      'H': '#FF9E99',
      'HT': '#FF9E99',
      'UHT': '#FF9E99',
      'LUHT': '#FF9E99',
      'LUHTS': '#FF9E99',
      'HTS': '#FF9E99',
      'UHTS': '#FF9E99',
      'T': '#8FD9FB',
      'TS': '#8FD9FB',
      'S': '#FFEE8C',
      'FMP': '#cdb1ca',
      'ŠS': '#cdb1ca',
      'ŠS/FMP': '#cdb1ca',
      'SATCO': '#cdb1ca',
      'SB': '#808080',
      'P': '#808080',
      'LUHTS E/P': '#808080'
    };
    return colorMap[props?.sectorShortName] || 'gray';
  }};
`;

export const BottomLine = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${props => props.backgroundColor};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;


export const HourLabelsCell = styled.div`
  width: 100%;
  height: 20px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  margin-left: -15px;
  //gap: 20px;
  gap: 27.5px;
  margin-top: -2px;
  background-color: rgb(230, 230, 230);
`;

export const HourTicksCell = styled.div`
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: space-between;
  /* flex-grow: 1;
  flex-basis: 0; */
  align-items: flex-end;
  &:first-child {
    border-left: 1px solid black;
  }
`;

export const HourTick = styled.div`
  border-right: 1px solid black;
 // flex: 1 1 0;
 // flex: 1 0 0;
  height: 10px;
  //padding-right: 17.5px;
  padding-right: 20.4px;
`;

export const HalfHourTick = styled.div`
  border-right: 1px solid black;
  border-left: none !important;
  margin-top: 5px;
  height: 5px;
  width: 50%;
  padding-right: 22px;
`;

export const HourCaptionWrapper = styled.div`
  height: 20px;
  width: 100%;
`;

export const HourCaption = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  margin-left: 50%;
  line-height: 30px;
`;

export const FirstHourCaption = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  margin-left: -50%;
  line-height: 30px;
  position:absolute;
`;

export const VersionCell = styled.div`
  // background-color: #5f5f5f;
  width: 160px;
  color: #262626;
  border-radius: 5px;
  // border: 1px solid #C5C5C5;
  font-weight: 500;
  text-align: center;
  line-height: 35px;
  z-index: 3;
`;

export const TwoHoursCellContainer = styled.div`
 // width: calc(100% - 160px);
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0px;
  margin-left: 0px;
`;

export const SheetHeadingContainer = styled.div`
  position: sticky;
  top: 0;
 // background-color: #efefef;
  width: 100%;
  padding-bottom: 5px;
  display: flex;
  // border: 1px solid blue;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  z-index: 2;
  box-sizing: border-box;
`;
